<div cdkDropListGroup class="cdk-group onsip-grid-placement">
  <div
    cdkDropList
    [cdkDropListData]="unselectedMembers"
    class="member-list first-column"
    (cdkDropListDropped)="drop($event)"
  >
    @for (item of unselectedMembers; track item) {
    <div
      class="member-item"
      cdkDrag
      [cdkDragData]="item"
      [cdkDragDisabled]="
        (item.type === 'telephone_number' && maxExternalCountReached) ||
        selectedMembers.length >= maxItemCount
      "
    >
      <div class="drag-placeholder" *cdkDragPlaceholder></div>
      <mat-card class="member-box">
        <span class="member-info">
          <span class="mat-body-2 member-name">
            {{ item.name }}
          </span>
          <span class="mat-body-2 member-type">
            {{ item.type | invokeFunction : showMemberType }}
          </span>
        </span>
        <span class="member-drag-indicator"
          ><mat-icon color="primary">drag_indicator</mat-icon></span
        >
      </mat-card>
    </div>
    }
  </div>
  <div
    cdkDropList
    [cdkDropListData]="selectedMembers"
    class="member-list second-column"
    [ngClass]="{ 'empty-member-list': selectedMembers.length === 0 }"
    (cdkDropListDropped)="drop($event)"
  >
    @if (!!selectedMembers.length) { @for (item of selectedMembers; track item; let i = $index) {
    <div class="member-item member-item-drop" cdkDrag [cdkDragData]="item">
      <div class="drag-placeholder" *cdkDragPlaceholder></div>
      <mat-card class="member-box member-box_counter">
        <span class="member-counter mat-body-2">{{ i + 1 }}</span>
      </mat-card>
      <mat-card class="member-box">
        <span class="member-info">
          <span class="mat-body-2 member-name">
            {{ item.name }}
          </span>
          <span class="mat-body-2 member-type">
            {{ item.type | invokeFunction : showMemberType }}
          </span>
        </span>
        <span class="member-drag-indicator"
          ><mat-icon color="primary">drag_indicator</mat-icon></span
        >
      </mat-card>
    </div>
    } } @else {
    <div class="empty-state">
      <span class="mat-body-2"
        >Drag members from the list on the left and drop into a group on the right.</span
      >
      <ul class="empty-state__list">
        <li class="mat-body-2">Only a maximum of 10 members can be dragged into a group.</li>
        <li class="mat-body-2">Drag and drop members into the order you want calls to ring.</li>
      </ul>
    </div>
    }
  </div>
  <!-- <div
    *ngIf="selectedMembers.length === 0"
    cdkDropList
    [cdkDropListData]="selectedMembers"
    #selectedMembersList = "cdkDropList"
    [cdkDropListConnectedTo]="[unselectedMembersList]"
    class="member-list empty-member-list second-column"
    (cdkDropListDropped)="drop($event)">
    <div class="empty-state-text mat-body-2">Drag and drop to make a selection</div>
  </div> -->
</div>
